export const RESET = 'USER_LIST_RESET';
export const SET_ITEMS = 'USER_LIST_SET_ITEMS';
export const SET_LINKS = 'USER_LIST_SET_LINKS';
export const SET_META = 'USER_LIST_SET_META';
export const SET_ERROR = 'USER_LIST_SET_ERROR';
export const SET_SELECT_ITEMS = 'USER_LIST_SET_SELECT_ITEMS';
export const TOGGLE_LOADING = 'USER_LIST_TOGGLE_LOADING';
export const SET_LIST_REFRESH = 'USER_LIST_SET_LIST_REFRESH';
export const SET_LOADING = 'USER_LIST_SET_LOADING';
